import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants";
import { ChangeProductVariantVisibilityRequestBody } from "./changeProductVariantVisibility.types";

export const requestChangeProductVariantVisibility = async ({
  id,
  ...body
}: ChangeProductVariantVisibilityRequestBody): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesProducts.ProductVariant,
      id,
      ApiRoutesProducts.ProductVariantVisibility
    ),
    body
  );
};
